<template>
  <div class="loginPage">
    <div class="login_content">
      <div class="cont">
        <div class="lc_left">
          <div class="sch_introduce">
            <div class="si_one">
              <div class="si_one_l">
                <img src="../assets/login/1.jpg" alt="" />
              </div>
              <div class="si_one_r">
                <div class="si_one_r_t">学校介绍</div>
                <div class="si_one_r_d">成都理工大学简介</div>
                <div style="margin-top: 15px" class="btn_style">
                  <a
                    href="https://www.cdut.edu.cn/xygk/xxjj.htm"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <el-button type="danger" size="mini" round
                      >查看详情
                    </el-button>
                  </a>
                </div>
              </div>
            </div>
            <div class="si_two">
              <div class="si_two_l">
                <img src="../assets/login/2.jpg" alt="" />
              </div>
              <div class="si_two_r">
                <div class="si_two_r_t">招生简章</div>
                <div class="si_two_r_d">高等教育自学考试助学招生简章</div>
                <div style="margin-top: 15px" class="btn_style">
                  <el-button
                    type="primary"
                    size="mini"
                    round
                    @click="lookDetails"
                    >查看详情
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="title">
            <div class="mes">
              <div class="mes_l">通知与公告</div>
              <div class="mes_r">MORE</div>
            </div>
          </div>
          <div class="notice">
            <div class="notice_item">
              <div class="ni_l">
                <span>
                  <span class="title-style">报名考次</span>
                  &emsp;第{{ applyTimeData.kaoc }}次
                </span>
              </div>
            </div>
            <div
              v-for="(item, index) in applyTimeData.date_list"
              :key="'date' + index"
              class="notice_item"
            >
              <div class="ni_l">
                <span>
                  <span class="title-style">{{ item.date_name }}</span>
                  &emsp;{{ item.date }}
                </span>
              </div>
            </div>
            <!--            <div class="notice_item">-->
            <!--              <div class="ni_l">-->
            <!--                <span>-->
            <!--                  <span class="title-style">缴费时间</span>-->
            <!--                  &emsp;{{ applyTimeData.payDate }}-->
            <!--                </span>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="notice_item">-->
            <!--              <div class="ni_l">-->
            <!--                <span>-->
            <!--                  <span class="title-style">信息完善时间</span>-->
            <!--                  &emsp;{{ applyTimeData.dataCompleteDate }}-->
            <!--                </span>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="lc_right">
          <div class="sh_img">
            <img class="sh1" src="../assets/login/new_login_logo.png" alt="" />
          </div>
          <div class="title">
            <img src="../assets/login/logo2.png" alt="" />
          </div>
          <div class="login_form">
            <div class="lf_title">已报名学员登录</div>
            <div class="login_input">
              <div class="login_input_item login_input_item_sfz">
                <img src="../assets/login/account.png" alt="" />
                <input
                  type="text"
                  v-model="user"
                  maxlength="18"
                  placeholder="请输入身份证"
                />
              </div>
              <div class="login_input_item login_input_item_sfz">
                <img src="../assets/login/password1.png" alt="" />
                <input
                  v-model="password"
                  type="password"
                  maxlength="6"
                  placeholder="请输入密码"
                />
              </div>
              <div class="login_input_item">
                <img src="../assets/login/testImg.png" alt="" />
                <input
                  v-model="rmInput"
                  placeholder="请输入图形验证码"
                  type="text"
                  maxlength="4"
                />
                <img :src="rmImg" class="rmImg" alt="" @click="getRmImg()" />
              </div>
            </div>
            <div class="login_button">
              <div class="log_btn" @click="login">登录</div>
              <div class="sign_btn" @click="signUp">学员报名</div>
            </div>
          </div>
          <div class="pay-area">
            <!-- <span class="pay-link" @click="toSecondGradePay"
              >第二年培训费缴纳>></span
            > -->
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-text footer-text-one">
        <span
          >请使用谷歌、edge，或其他第三方浏览器（360、搜狗等浏览器）的高速模式访问本系统</span
        >
      </div>
      <div class="footer-text"><span>成都理工大学继续教育学院</span></div>
    </div>
    <el-dialog
      title="请手机扫码报名"
      center
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div class="imgBox">
        <img src="./trainCostPayment/img/pic20230222182934.png" alt="" />
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>
<script>
import webConfig from "@/utils/webSite/webSite.js";
import { reqQueryApplyGuide } from "@/request/login";
import { getNowKaoc, getOperationTime } from "@/request/initData";
import { getRandomImgCode, passwordEncryption,decryptPwd } from "@/utils/util";

export default {
  name: "LoginIndex",
  data() {
    return {
      // 密码是身份证后六位
      // user: '511321199406032587',
      // user: '110106200002140978',
      // password: '032587'
      user: "",
      password: "",
      rmInput: "",
      rmNum: "",
      rmImg: "",
      dialogVisible: false,
      applyTimeData: {
        kaoc: "",
        date_list: [],
      },
    };
  },
  created() {
    this.getOperationData();
    this.getRmImg();
  },
  mounted(){
    // 页面加载时调用一次
    window.addEventListener("load", this.setRemUnit);
    // 监听窗口大小变化，以便在用户调整浏览器窗口大小时重新计算
    window.addEventListener("resize", this.setRemUnit);
  },
  beforeDestroy(){
    window.removeEventListener('resize',this.setRemUnit)
  },
  methods: {
    setRemUnit() {
      // 基准宽度和对应的 1rem 大小
      const baseWidth = 1920; // 基准宽度
      const baseFontSize = 16; // 在基准宽度下 1rem 对应的 px 值
      // 获取当前屏幕宽度
      const currentWidth = window.innerWidth;
      // 计算新的 1rem 大小
      const newFontSize = (currentWidth / baseWidth) * baseFontSize;
 
      // 设置 HTML 根元素的字体大小
      document.documentElement.style.fontSize = `${newFontSize}px`;
    },
    open_page(url) {
      // 打开新窗口
      setTimeout(() => {
        // const formEle = document.createElement('form')
        // formEle.style.display = 'none'
        // formEle.method = 'post'
        // formEle.target = '_blank'
        // formEle.action = url
        // document.body.appendChild(formEle)
        // formEle.submit()
        // formEle.remove()

        const el = document.createElement("a");
        document.body.appendChild(el);
        el.href = encodeURI(url);
        el.target = "_blank";
        el.click();
        document.body.removeChild(el);
      }, 100);
    },
    login() {
      if (!this.user) {
        this.$message.error("请输入身份证！");
        return;
      }
      // if (!/(^\d{15}$)|(^\d{17}(\d|x|X)$)/.test(this.user)) {
      //   this.$message.error("请输入正确的身份证！");
      //   return;
      // }
      if (!this.password) {
        this.$message.error("请输入密码！");
        return;
      }
      if (!this.rmInput) {
        this.$message.error("请输入验证码！");
        return;
      }
      this.$store
        .dispatch("stuLogin", {
          user: this.user.toUpperCase().replace(/\s*/g, ""),
          pwd: passwordEncryption(this.password),
          rmInput: this.rmInput,
          rmNum: this.rmNum,
        })
        .then((_) => {
          this.getRmImg();
        })
        .catch((_) => {
          this.getRmImg();
        });
    },
    iWantApply() {
      this.$router.push("/main/applyNotice");
    },
    lookDetails() {
      reqQueryApplyGuide({}).then((res) => {
        if (res.result.length > 0) {
          if (res.result[0].file_type === 2) {
            const url = webConfig.webSite + res.result[0].file_path;
            this.open_page(url);
          } else {
            const url = res.result[0].file_path;
            this.open_page(url);
          }
        } else {
          this.$message.error("暂无招生简章");
        }
      });
    },
    signUp() {
      // reqGetPayQRcode({}).then(res => {
      //   this.imgUrl = webConfig.webSite + res.path
      // })
      // this.dialogVisible = true
      this.$store.commit("clearUserApplyData");
      let href = window.location.href.split("#");
      href = href[0] + "#/applyMain";
      window.location.href = href;
      // this.$router.push('/applyMain')
    },
    getOperationData() {
      const param = {
        apply_type: 1,
      };
      getNowKaoc(param).then((res) => {
        this.applyTimeData.kaoc = res.result;
      });
      const params = {
        v_branch_id: "",
      };
      getOperationTime(params).then((res) => {
        this.applyTimeData.date_list = res.result
          .filter((v) => v.apply_type <= 3)
          .map((v) => {
            return {
              date_name: v.type_name,
              date: v.beg_date + " 至 " + v.end_date,
            };
          });
      });
    },
    getRmImg() {
      this.rmInput = "";
      const obj = getRandomImgCode();
      this.rmNum = obj.rmNum;
      this.rmImg = obj.rmImgUrl;
    },
    // 前往二年级缴费
    toSecondGradePay() {
      window.open( location.origin + '/#/secondGradePay/payInfo','_blank')
      // this.$router.push("/secondGradePay/payInfo");
    },
  },
};
</script>
<style scoped lang="less">
.loginPage {
  position: relative;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding-top: 4.9rem;
  overflow-x: auto;
  background: url("../assets/login/loginback.jpg");
  background-repeat: 100% 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;

  .login_content {
    margin: auto;
    width: 75rem;
    height: 43.75rem;
    border-radius: 1.25rem;
    background: #f9fafc;
    box-sizing: border-box;
    overflow: hidden;

    .cont {
      height: 100%;
      width: 100%;

      display: flex;

      .lc_left {
        background: #f9fafc;
        width: 37.5rem;
        height: 100%;

        .title {
          padding: 2.5rem 2.375rem 0 2.5rem;
          width: 100%;
          box-sizing: border-box;

          .mes {
            height: 2.0625rem;
            box-sizing: border-box;
            width: 100%;
            position: relative;
            border-bottom: 0.0625rem solid #cccccc;

            .mes_l {
              font-size: 1rem;
              width: 5rem;
              padding-bottom: 0.9375rem;
              border-bottom: 0.125rem solid #157dcb;
              line-height: 1;
              color: #157dcb;
              position: absolute;
              top: 0;
              left: 0;
            }

            .mes_r {
              font-family: "Microsoft YaHei", serif;
              position: absolute;
              right: 0;
              bottom: 1.0625rem;
              color: #999999;
              font-size: 0.75rem;
              line-height: 1;
            }
          }
        }

        .notice {
          // padding: ;
          width: 100%;
          padding: 0 2.3125rem 0 2.6875rem;
          box-sizing: border-box;

          .notice_item {
            display: flex;
            justify-content: space-between;
            border-bottom: 0.0625rem solid #f0f0f0;

            .ni_l {
              font-family: "Microsoft YaHei", serif;
              width: 26.8125rem;
              color: #333333;
              font-size: 0.875rem;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              //padding: 14px 0 16px;
              padding: 1.25rem 0 1.25rem;
              .title-style {
                display: inline-block;
                width: 5.625rem;
                font-weight: bold;
                color: #000;
                text-align: right;
              }
            }

            .ni_r {
              font-family: "Microsoft YaHei", serif;
              padding-top: 0.875rem;
              box-sizing: border-box;
              color: #999999;
              font-size: 0.875rem;
              display: flex;
              align-items: flex-start;
              height: 2rem;
            }
          }
        }

        .sch_introduce {
          padding: 2.125rem 0 0 4.4375rem;

          .si_one {
            width: 28.75rem;
            height: 7.5rem;
            position: relative;
            background: #ffd3d4;
            border-radius: 0.25rem;
            display: flex;
            margin-bottom: 1.6875rem;

            .si_one_l {
              font-size: 0;
              padding: 0.9375rem 1.5rem;

              img {
                width: 9.375rem;
                height: 5.625rem;
              }
            }

            .si_one_r {
              padding-top: 1rem;

              .si_one_r_t {
                font-weight: 800;
                color: #d52a2e;
                font-size: 1.125rem;
                line-height: 1;
                margin-bottom: 1rem;
              }

              .si_one_r_d {
                color: #ed5a5e;
                font-size: 0.75rem;
                line-height: 1;
              }
              .btn_style{
                    margin-top: 0.9375rem !important;
                    .el-button{
                      padding: 0.4375rem 0.9375rem !important;
                      font-size: 0.75rem !important;
                    }
                  }
            }
          }

          .si_two {
            width: 28.75rem;
            height: 7.5rem;
            background: #aed9fc;
            border-radius: 0.25rem;
            position: relative;
            display: flex;

            .si_two_l {
              font-size: 0;
              padding: 0.9375rem 1.5rem;

              img {
                width: 9.375rem;
                height: 5.625rem;
              }
            }

            .si_two_r {
              padding-top: 1rem;

              .si_two_r_t {
                font-weight: 800;
                color: #157ccf;
                font-size: 1.125rem;
                line-height: 1;
                margin-bottom: 1rem;
              }

              .si_two_r_d {
                color: #419de8;
                font-size: 0.75rem;
                line-height: 1;
                
              }
              .btn_style{
                    margin-top: 0.9375rem !important;
                    .el-button{
                      padding: 0.4375rem 0.9375rem !important;
                      font-size: 0.75rem !important;
                    }
                  }
            }
          }
        }
      }

      .lc_right {
        background: #ffffff;
        width: 37.5rem;
        height: 100%;

        .sh_img {
          font-size: 0;
          padding: 1.875rem 0 1.875rem 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          .sh1 {
            width: 28.25rem;
            height: 4.71rem;
          }
        }

        .title {
          font-size: 0;
          text-align: center;
          margin-bottom: 3.125rem;

          img {
            width: 27.3125rem;
            height: 1.5625rem;
          }
        }

        .login_form {
          padding-top: 2.1875rem;
          width: 27.25rem;
          height: 23.4375rem;
          background: #ffffff;
          border-radius: 0.625rem 0.625rem 0.625rem 0.625rem;
          box-shadow: 0 0.125rem 0.75rem 0 rgb(0 0 0 / 10%);
          margin: auto;
          .lf_title {
            font-weight: 800;
            color: #333333;
            font-size: 1.125rem;
            line-height: 1;
            text-align: center;
            width: 100%;
            margin-bottom: 1.5625rem;
          }
          .login_input {
            width: 21.875rem;
            margin: auto;
          }
          .login_input {
            margin-bottom: 1.875rem;
            .login_input_item_sfz {
              margin-bottom: 1.5625rem !important;
            }
            .login_input_item {
              height: 2.5rem;
              position: relative;
              img:not(.rmImg) {
                width: 1.25rem;
                height: 1.25rem;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: 0.625rem;
              }
              .rmImg {
                width: 7.5rem;
                height: 2.5rem;
                position: absolute;
                right: 0.3215rem;
                top: 50%;
                transform: translateY(-60%);
                cursor: pointer;
              }
              input {
                border: 0;
                width: 100%;
                border-bottom: 0.0625rem solid #cccccc;
                height: 2.5rem;
                padding-left: 2.5rem;
                font-size: 1rem;
                box-sizing: border-box;
                &:focus {
                  outline: 0 !important;
                }
                &::placeholder {
                  color: #ababab;
                  font-size: 0.9375rem;
                }
              }
            }
          }
          .login_button {
            .log_btn,
            .sign_btn {
              width: 21.25rem;
              height: 2.75rem;
              background: #157dcb;
              border-radius: 1.375rem;
              line-height: 2.75rem;
              margin: auto;
              text-align: center;
              cursor: pointer;
              font-size: 1rem;
              color: white;
            }
            .sign_btn {
              background: #0c814b;
              margin-top: 1.5625rem;
            }
          }
        }
        .pay-area {
          width: 27.25rem;
          margin: 1.25rem auto 0;
          text-align: right;
          padding-right: 1.25rem;
          box-sizing: border-box;
          .pay-link {
            cursor: pointer;
            user-select: none;
            color: #56a2ff;
          }
          .pay-link:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  .footer {
    text-align: center;
    color: white;
    margin: auto;
    font-size: 0.875rem;
    position: fixed;
    height: 4rem;
    width: 100vw;
    bottom: 0;
    box-sizing: border-box;
    .footer-text-one {
      margin-bottom: 0.875rem;
    }
  }
  .imgBox {
    margin: 0 auto;
    // margin-top: 100px;
    margin-bottom: 1.25rem;
    width: 20rem;
    height: 20rem;
    // background-color: pink;
  }
}

// 小于等于 1366px 宽度的屏幕全都适应
// @media only screen and (max-width: 1366px) {
//   .loginPage::v-deep {
//     position: relative;
//     height: 100%;
//     width: 100%;
//     box-sizing: border-box;
//     padding-top: 35px;
//     overflow-x: auto;
//     background: url("../assets/login/loginback.jpg");
//     background-repeat: 100% 100%;
//     background-repeat: no-repeat;

//     .login_content {
//       margin: auto;
//       width: 860px;
//       height: 500px;
//       border-radius: 20px;
//       background: #f9fafc;
//       box-sizing: border-box;
//       overflow: hidden;

//       .cont {
//         height: 100%;
//         width: 100%;

//         display: flex;

//         .lc_left {
//           background: #f9fafc;
//           width: 430px;
//           height: 100%;

//           .title {
//             padding: 28px 25px 0 28px;
//             width: 100%;
//             box-sizing: border-box;

//             .mes {
//               height: 23px;
//               box-sizing: border-box;
//               width: 100%;
//               position: relative;
//               border-bottom: 1px solid #cccccc;

//               .mes_l {
//                 font-size: 12px;
//                 width: 70px;
//                 padding-bottom: 11px;
//                 border-bottom: 2px solid #157dcb;
//                 line-height: 1;
//                 color: #157dcb;
//                 position: absolute;
//                 top: 0;
//                 left: 0;
//               }

//               .mes_r {
//                 font-family: "Microsoft YaHei", serif;
//                 position: absolute;
//                 right: 0;
//                 bottom: 11px;
//                 color: #999999;
//                 font-size: 12px;
//                 line-height: 1;
//               }
//             }
//           }

//           .notice {
//             // padding: ;
//             width: 100%;
//             padding: 0 28px 0 28px;
//             box-sizing: border-box;

//             .notice_item {
//               display: flex;
//               justify-content: space-between;
//               border-bottom: 1px solid #f0f0f0;

//               .ni_l {
//                 font-family: "Microsoft YaHei", serif;
//                 width: 429px;
//                 color: #333333;
//                 font-size: 12px;
//                 display: flex;
//                 justify-content: flex-start;
//                 align-items: flex-start;
//                 //padding: 14px 0 16px;
//                 padding: 14px 0 14px;
//                 .title-style {
//                   display: inline-block;
//                   width: 70px;
//                   font-weight: bold;
//                   color: #000;
//                   text-align: right;
//                 }
//               }

//               .ni_r {
//                 font-family: "Microsoft YaHei", serif;
//                 padding-top: 11px;
//                 box-sizing: border-box;
//                 color: #999999;
//                 font-size: 12px;
//                 display: flex;
//                 align-items: flex-start;
//                 height: 23px;
//               }
//             }
//           }

//           .sch_introduce {
//             padding: 34px 0 0 50px;

//             .si_one {
//               width: 330px;
//               height: 90px;
//               position: relative;
//               background: #ffd3d4;
//               border-radius: 4px;
//               display: flex;
//               margin-bottom: 21px;

//               .si_one_l {
//                 font-size: 0;
//                 padding: 10px 18px;

//                 img {
//                   width: 110px;
//                   height: 65px;
//                 }
//               }

//               .si_one_r {
//                 padding-top: 10px;

//                 .si_one_r_t {
//                   font-weight: 800;
//                   color: #d52a2e;
//                   font-size: 15px;
//                   line-height: 1;
//                   margin-bottom: 10px;
//                 }

//                 .si_one_r_d {
//                   color: #ed5a5e;
//                   font-size: 12px;
//                   line-height: 1;
              
//                 }
//                 .btn_style{
//                     margin-top: 6px !important;
//                     .el-button{
//                       padding: 5px 10px !important;
//                       font-size: 10px !important;
//                     }
//                   }
//               }
//             }

//             .si_two {
//               width: 330px;
//               height: 90px;
//               background: #aed9fc;
//               border-radius: 4px;
//               position: relative;
//               display: flex;

//               .si_two_l {
//                 font-size: 0;
//                 padding: 10px 18px;

//                 img {
//                   width: 110px;
//                   height: 65px;
//                 }
//               }

//               .si_two_r {
//                 padding-top: 10px;

//                 .si_two_r_t {
//                   font-weight: 800;
//                   color: #157ccf;
//                   font-size: 15px;
//                   line-height: 1;
//                   margin-bottom: 10px;
//                 }

//                 .si_two_r_d {
//                   color: #419de8;
//                   font-size: 12px;
//                   line-height: 1;
//                 }
//                 .btn_style{
//                     margin-top: 6px !important;
//                     .el-button{
//                       padding: 5px 10px !important;
//                       font-size: 10px !important;
//                     }
//                   }
//               }
//             }
//           }
//         }

//         .lc_right {
//           background: #ffffff;
//           width: 600px;
//           height: 100%;

//           .sh_img {
//             font-size: 0;
//             padding: 21px 0 21px 0px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             .sh1 {
//               width: 210px;
//               height: 55px;
//             }
//           }

//           .title {
//             font-size: 0;
//             text-align: center;
//             margin-bottom: 35px;

//             img {
//               width: 330px;
//               height: 19px;
//             }
//           }

//           .login_form {
//             padding-top: 23px;
//             width: 310px;
//             height: 280px;
//             background: #ffffff;
//             border-radius: 10px 10px 10px 10px;
//             box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
//             margin: auto;
//             .lf_title {
//               font-weight: 800;
//               color: #333333;
//               font-size: 14px;
//               line-height: 1;
//               text-align: center;
//               width: 100%;
//               margin-bottom: 16px;
//             }
//             .login_input {
//               width: 245px;
//               margin: auto;
//             }
//             .login_input {
//               margin-bottom: 21px;
//               .login_input_item_sfz {
//                 margin-bottom: 17px !important;
//               }
//               .login_input_item {
//                 height: 29px;
//                 position: relative;
//                 img:not(.rmImg) {
//                   width: 14px;
//                   height: 14px;
//                   position: absolute;
//                   top: 50%;
//                   transform: translateY(-50%);
//                   left: 7px;
//                 }
//                 .rmImg {
//                   width: 84px;
//                   height: 28px;
//                   position: absolute;
//                   right: 5px;
//                   top: 50%;
//                   transform: translateY(-60%);
//                   cursor: pointer;
//                 }
//                 input {
//                   border: 0;
//                   width: 100%;
//                   border-bottom: 1px solid #cccccc;
//                   height: 28px;
//                   padding-left: 28px;
//                   font-size: 13px;
//                   box-sizing: border-box;
//                   &:focus {
//                     outline: 0 !important;
//                   }
//                   &::placeholder {
//                     color: #ababab;
//                     font-size: 12px;
//                   }
//                 }
//               }
//             }
//             .login_button {
//               .log_btn,
//               .sign_btn {
//                 width: 239px;
//                 height: 31px;
//                 background: #157dcb;
//                 border-radius: 15px;
//                 line-height: 31px;
//                 margin: auto;
//                 text-align: center;
//                 cursor: pointer;
//                 font-size: 13px;
//                 color: white;
//               }
//               .sign_btn {
//                 background: #0c814b;
//                 margin-top: 13px;
//               }
//             }
//           }
//           .pay-area {
//             width: 310px;
//             margin: 14px auto 0;
//             text-align: right;
//             padding-right: 14px;
//             box-sizing: border-box;
//             .pay-link {
//               cursor: pointer;
//               user-select: none;
//               color: #56a2ff;
//               font-size: 12px;
//             }
//             .pay-link:hover {
//               text-decoration: underline;
//             }
//           }
//         }
//       }
//     }
//     .footer {
//       text-align: center;
//       color: white;
//       margin: auto;
//       margin-top: 20px;
//       padding-bottom: 5px;
//       font-size: 12px;
//       .footer-text-one {
//         margin-bottom: 8px;
//       }
//     }
//     .imgBox {
//       margin: 0 auto;
//       // margin-top: 100px;
//       margin-bottom: 20px;
//       width: 320px;
//       height: 320px;
//       // background-color: pink;
//     }
//   }
// }
@media only screen and (max-width: 1366px){
  .loginPage{
    padding-top: 2.8rem;
  }
}
// @media only screen and (max-width: 1300px){
//   .loginPage{
//     padding-top: 2rem;
//     .login_content{
//       height: 42.5rem;
//      }
//   }
// }
</style>
